import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const ERROR_TOAST_MS = 4000;
let lastKey = null;

export function pushErrorToast(snack, message = "Couldn't save changes. Try again.") {
  if (!snack?.enqueueSnackbar) return null;
  if (lastKey !== null) snack.closeSnackbar(lastKey);
  lastKey = snack.enqueueSnackbar(message, {
    variant: 'error',
    autoHideDuration: ERROR_TOAST_MS,
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    TransitionComponent: Slide,
    TransitionProps: { direction: 'down' },
    action: (key) => (
      <IconButton size="small" aria-label="Dismiss" onClick={() => snack.closeSnackbar(key)} sx={{ color: 'common.white' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    )
  });
  return lastKey;
}

export function useErrorToast() {
  const snack = useSnackbar();
  return useCallback((message) => pushErrorToast(snack, message), [snack]);
}
